import { useDrawer, DrawerComponent } from '~/shared/ui/Drawer'
import { InfoSmallOutlinedIcon } from '~/shared/ui/icons'
import {
  InfoIconWrapper,
  TitleWrapper,
  Wrapper,
  Title,
  PromoCodeTitle,
  PromoCodeDescription,
} from './styled'

type PriceContentDrawerProps = {
  title: string
  description: string
}

export function PriceContentDrawer({
  title,
  description,
}: PriceContentDrawerProps) {
  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  return (
    <>
      <Wrapper onClick={openDrawer}>
        <TitleWrapper>
          <InfoIconWrapper>
            <InfoSmallOutlinedIcon />
          </InfoIconWrapper>
        </TitleWrapper>
      </Wrapper>
      <DrawerComponent isShow={isDrawerShow} onCancel={closeDrawer}>
        <Title>Детали цены</Title>
        <PromoCodeTitle>{title}</PromoCodeTitle>
        <PromoCodeDescription>{description}</PromoCodeDescription>
      </DrawerComponent>
    </>
  )
}
